<template>
  <BaseModal
    :is-open="isOpen"
    :show-default-footer="false"
    :close-on-overlay-click="true"
    :close-on-escape="true"
    :showCloseButton="true"
    content-padding="none"
    size="sm"
    title="계좌 비밀번호"
    @close="handleClose"
  >
    <div class="gap-size-36 pt-size-50 pb-size-40 px-size-50 flex flex-col">
      <div class="gap-size-12 flex flex-col items-center justify-center">
        <p class="text-font-16 font-medium">계좌 비밀번호가 재설정 되었어요</p>
      </div>
      <!-- 버튼 영역 -->
      <div class="gap-size-10 flex w-full items-center justify-center">
        <BaseButton
          label="확인"
          variant="contained"
          color="primary"
          size="md"
          @click="handleClose"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { useGlobalDialogManager } from '@/composables/useGlobalDialogManager';
import { BaseModal, BaseButton } from '@template/ui';

const isOpen = defineModel<boolean>('isOpen', { required: true, default: false });
const globalDialogManager = useGlobalDialogManager();

const handleClose = () => {
  isOpen.value = false;
  globalDialogManager.closeAll();
};
</script>
